var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3579 17.965L17.5114 21.1494C17.3706 21.3922 17.1083 21.5444 16.8217 21.5444H5.17753C4.89086 21.5444 4.62862 21.3922 4.48784 21.1494L2.64129 17.965H19.3579Z",
    stroke: "#508BEF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 17.3758L17.8633 20.5436L9.50152 6.13672H13.1698C13.4564 6.13672 13.7186 6.2888 13.8594 6.53141L19.7001 16.5946C19.8405 16.8365 19.8405 17.1338 19.7002 17.3758Z",
    stroke: "#508BEF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13642 20.5436L2.29952 17.3758C2.15922 17.1338 2.15928 16.8365 2.29968 16.5946L8.14039 6.53141C8.2812 6.2888 8.54336 6.13672 8.82991 6.13672H12.4982L4.13642 20.5436Z",
    stroke: "#508BEF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3582 17.965L17.8631 20.5434L16.3665 17.965H19.3582Z",
    stroke: "#508BEF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 8.71877L9.50152 6.13672H12.4988L11.0002 8.71877Z",
    stroke: "#508BEF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86698 17.6264C1.83662 17.574 1.81026 17.5201 1.78791 17.465H6.50127L4.14169 21.5304C4.1105 21.4891 4.08162 21.4457 4.0553 21.4003L1.86698 17.6264Z",
    stroke: "#508BEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L15 12L11 13L12 9L18.5 2.49998Z",
    fill: "white",
    stroke: "#508BEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDrive);
export default __webpack_public_path__ + "static/media/edit-drive.a2d2564f997065819f5139bc34058f7e.svg";
export { ForwardRef as ReactComponent };